export type Colour = 'black' | 'blue' | 'red' | 'green' | 'magenta' | 'yellow' | 'cyan' | 'white' | undefined;

export type Guess = Colour[];

export interface Score {
  white: number;
  black: number;
}

export interface Play {
  guess: Guess;
  score?: Score;
}

export interface Game {
  goal: Guess;
  plays: Play[];
  quit: boolean;
}

export const colours: Colour[] = ['black', 'blue', 'red', 'green', 'magenta', 'yellow', 'cyan', 'white'];

export const randomColour = () => colours[Math.floor(Math.random() * colours.length)];

export const createScore = (): Score => ({
  black: 0,
  white: 0
});

export const createGuess = (): Guess => [undefined, undefined, undefined, undefined];

export const createPlay = (): Play => ({
  guess: createGuess()
});

export const createGame = (): Game => ({
  goal: [randomColour(), randomColour(), randomColour(), randomColour()],
  plays: [createPlay()],
  quit: false
});
